<script lang="ts">
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import { mdiFileDocumentOutline, mdiReload } from "@mdi/js"

  import type {
    StartLetterPrintJobIntent,
    StartLetterPrintJobOperations,
    StartLetterPrintJobPhase,
    StartLetterPrintJobResult,
  } from "../../actions/startLetterPrintJob"

  let {
    intent,
    operations,
    onSubmissionResult,
    onPhaseChange = undefined,
  }: {
    intent: StartLetterPrintJobIntent
    operations: StartLetterPrintJobOperations
    onSubmissionResult: (result: StartLetterPrintJobResult) => void | Promise<void>
    onPhaseChange?: (phase: StartLetterPrintJobPhase) => void
  } = $props()

  let pending = $state(false)

  const run = async () => {
    if (pending || intent.kind !== "start") return

    pending = true
    onPhaseChange?.("starting")
    let status: Awaited<ReturnType<StartLetterPrintJobOperations["startPrintJob"]>>
    try {
      status = await operations.startPrintJob({
        organization_id: intent.organizationId,
        manual_delivery_item_ids: [...intent.itemIds],
      })
    } catch (error) {
      console.error("letter_delivery_manual_print_job_start_failed", error)
      newNotification({
        class: "error",
        html: "Zustell-Druckauftrag konnte nicht gestartet werden.",
      })
      pending = false
      onPhaseChange?.("idle")

      return
    }

    try {
      await onSubmissionResult({ kind: "started", status, itemIds: [...intent.itemIds] })
    } catch (error) {
      console.error("letter_delivery_manual_print_job_post_start_failed", error)
      newNotification({
        class: "error",
        html: "Druckauftrag gestartet, Oberfläche konnte nicht aktualisiert werden.",
      })
    } finally {
      pending = false
      onPhaseChange?.("idle")
    }
  }
</script>

<CTA
  type={intent.label === "PDF erneut vorbereiten" ? "secondaryButton" : "primaryButton"}
  content={pending ? "Rendern läuft" : intent.label}
  disabled={pending || intent.kind === "blocked"}
  tooltipContent={intent.kind === "blocked" ? intent.disabledReason : undefined}
  onClick={() => void run()}
>
  {#snippet iconSnippet()}
    <Icon path={intent.label === "PDF erneut vorbereiten" ? mdiReload : mdiFileDocumentOutline} />
  {/snippet}
</CTA>
